import { v4 as uuidv4 } from "uuid";
import { RECEIVE_CHAT_DETAILS, RECEIVE_MYDPD_CHAT_DETAILS, SHOW_CHAT_PROMPT, SHOW_CHAT_PANEL, HIDE_CHAT_PANEL, CLOSE_CHAT, RESET_CONFIG_STATE } from "./Constants";
const initialState = {
  showChatBar: false,
  showChatPanel: false,
  supported: true,
  delay: 0,
  available: false,
  maximize: false,
  suborigin: false,
  businessUnit: 1
};

function config(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_CHAT_DETAILS:
      return Object.assign({}, state, {
        id: uuidv4(),
        available: action.details.available,
        maximize: action.details.maximize,
        suborigin: action.details.subOrigin,
        delay: action.details.delay || 0,
        showChatBar: false,
        showChatPanel: false,
        businessUnit: action.details.businessUnit,
        advisorPass: action.details.advisorPass,
        timeoutClosure: parseInt(action.details.timeoutClosure, 10),
        tmpContact: action.details.tmpContact
      });

    case RECEIVE_MYDPD_CHAT_DETAILS:
      {
        const accountData = action.details.accountsEnabled || [];
        return Object.assign({}, state, {
          id: uuidv4(),
          available: action.details.botAvailable,
          advisorAvailable: action.details.advisorAvailable,
          accounts: accountData.map(account => account.accountId),
          accountData,
          maximize: false,
          suborigin: false,
          delay: action.details.loadTime || 0,
          showChatBar: false,
          showChatPanel: false,
          businessUnit: action.details.businessUnit,
          advisorPass: action.details.advisorHandover,
          timeoutClosure: 10000,
          tmpContact: 1,
          showDirectly: action.details.showDirectly,
          serviceWindow: action.details.serviceWindow,
          mydpdQueueAvailable: action.details.queueAvailable,
          initialQuestions: action.details.questions,
          outOfHours: action.details.outOfHours,
          transcript: action.details.transcript,
          parcelCode: action.details.parcelCode,
          queueType: action.details.queueType,
          caseId: action.details.caseId
        });
      }

    case SHOW_CHAT_PROMPT:
      return Object.assign({}, state, {
        showChatBar: true,
        showChatPanel: false
      });

    case SHOW_CHAT_PANEL:
      return Object.assign({}, state, {
        showChatBar: false,
        showChatPanel: true,
        flag: action.flag || null
      });

    case HIDE_CHAT_PANEL:
      return Object.assign({}, state, {
        showChatBar: true,
        showChatPanel: false
      });

    case CLOSE_CHAT:
      return Object.assign({}, state, {
        showChatBar: false,
        showChatPanel: false
      });

    case RESET_CONFIG_STATE:
      return initialState;

    default:
      return state;
  }
}

export default config;